import "./CardDisplay.css";
import CardTemplate from "./CardTemplate";

export default function CardDisplay() {
  return (
    <div className="card-display">
      <div className="container">
        <CardTemplate />
      </div>
    </div>
  );
}
